import { docodeHexResponse } from "../../_common/common.utils";
import WebEnquiryTypes from "./webEnquiry.types";

const INITIAL_STATE: any = {
  webEnquiryFetchResponseArr: [],
  webEnquiryFetchResponse: null,
  webEnquiryExportResponse: null,
  webEnquiryExportResponseArr: [],
  exportWebEnquiryStatus: "",
};

const webEnquiryReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case WebEnquiryTypes.WEB_ENQUIRY_FETCH_SUCCESS:
      return {
        ...state,
        webEnquiryFetchResponse: action.payload,
        webEnquiryFetchResponseArr: docodeHexResponse(
          action.payload,
          "FetchEnquiryListJSONKey",
        ),
      };

    case WebEnquiryTypes.WEB_ENQUIRY_FETCH_FAILURE:
      return {
        ...state,
        webEnquiryFetchResponse: action.payload,
        webEnquiryFetchResponseArr: [],
      };

    case WebEnquiryTypes.WEB_ENQUIRY_FETCH_RESPONSE_CHANGED:
      return {
        ...state,
        webEnquiryFetchResponse: null,
        webEnquiryFetchResponseArr: [],
      };

    case WebEnquiryTypes.WEB_ENQUIRY_EXPORT_SUCCESS:
      try {
        return {
          ...state,
          webEnquiryExportResponse: action.payload,
          webEnquiryExportResponseArr: action.payload?.response
            ? docodeHexResponse(action.payload, "createRequestReportKey")
            : [],
          exportWebEnquiryStatus: "Success",
        };
      } catch (error) {
        console.error("Error decoding export response:", error);
        return {
          ...state,
          webEnquiryExportResponse: action.payload,
          webEnquiryExportResponseArr: [],
          exportWebEnquiryStatus: "Success",
        };
      }

    case WebEnquiryTypes.WEB_ENQUIRY_EXPORT_FAILURE:
      return {
        ...state,
        webEnquiryExportResponse: action.payload,
        webEnquiryExportResponseArr: [],
        exportWebEnquiryStatus: "Failure",
      };

    case WebEnquiryTypes.WEB_ENQUIRY_EXPORT_CHANGED:
      return {
        ...state,
        webEnquiryExportResponse: null,
        exportWebEnquiryStatus: "",
      };

    default:
      return state;
  }
};

export default webEnquiryReducer;
